import {
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
} from "@heroicons/react/20/solid";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Actions as ADMINACTIONS } from "../../store/actions/adminActions";
import { Actions as ADVISORACTIONS } from "../../store/actions/advisorActions";
import { Actions as COMPANYACTIONS } from "../../store/actions/companyActions";
import PaymentHandlingRow from "./PaymentHandlingRow";

const PaymentHandling = ({ currency, organisations, getAdminOrganisations, getAdvisorList, getPaymentHandle }) => {
	const [search, setSearch] = useState("");
	const [itemsPerPage, setItemsPerPage] = useState(20);
	const [page, setPage] = useState(0);
	const start = page * itemsPerPage;
	const end = (page + 1) * itemsPerPage;

	const filteredCompanyList = useMemo(() => {
		const filterByValue = (o) =>
			["senderName"].some((k) => String(o[k])?.toLowerCase().includes(search.toLowerCase()));

		return search.replace(/\s/g, "") ? organisations?.filter(filterByValue) : organisations;
	}, [search, organisations]);

	const lastPage = Math.ceil((filteredCompanyList?.length || 1) / itemsPerPage);

	useEffect(() => {
		getPaymentHandle();
	}, []);

	const Pagination = () => {
		if (filteredCompanyList?.length <= 0) return null;
		return (
			<thead>
				<tr>
					<th colSpan={7}>
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go To Page 1"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(0);
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 5 Pages"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(Math.max(page - 5, 0));
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 1 Page"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(page - 1);
									}}
									disabled={page === 0}
								>
									<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<strong>
									Page {page + 1}/{lastPage}
								</strong>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title={`Go to Page ${lastPage}`}
									onClick={() => {
										if (page !== lastPage - 1) setPage(lastPage - 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title="Go Forward 5 Pages"
									onClick={() => {
										if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									title="Go Forward 1 Page"
									onClick={() => {
										if (page !== lastPage - 1) setPage(page + 1);
									}}
									style={{ marginRight: "0.5rem" }}
									disabled={page === lastPage - 1}
								>
									<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		);
	};

	useEffect(() => {
		getAdminOrganisations();
		getAdvisorList();
	}, []);

	return (
		<>
			<div
				className="content"
				style={{ overflow: "show" }}
			>
				<div
					className="block-content"
					style={{ minHeight: "fit-content" }}
				>
					<table
						id="table-timesheets"
						className="table-responsive table table-hover"
					>
						<Pagination />
						<thead>
							<tr>
								<th className="text-left">Sender Name</th>
								<th style={{ textAlign: "center" }}>Amount</th>
								<th style={{ textAlign: "center" }}>Timestamp</th>

								<th width="5%" />
							</tr>
						</thead>
						<tbody>
							{filteredCompanyList?.length > 0 ? (
								filteredCompanyList?.slice(start, end)?.map((client) => (
									<PaymentHandlingRow
										key={client.id}
										client={client}
									/>
								))
							) : (
								<tr>
									<th colSpan={4}>No Payments{search ? ` matching "${search}"` : null}.</th>
								</tr>
							)}
						</tbody>
						<Pagination />
					</table>
					<div className="clearfix" />
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		currency: state.company?.settings?.currency,
		// organisations: state?.admin?.organisations || [],
		organisations: state.admin?.paymentHandles,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAdminOrganisations: () => dispatch(COMPANYACTIONS.getAdminOrganisations()),
	getAdvisorList: () => dispatch(ADVISORACTIONS.getAdvisorList()),
	getPaymentHandle: () => dispatch(ADMINACTIONS.getPaymentHandle()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHandling);
